import React, { Component } from "react";

// Form Editor

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { FormHelperText, FormLabel } from "@mui/material";
import { Alignment, Bold, ClassicEditor, Essentials, FontBackgroundColor, FontColor, FontFamily, FontSize, HorizontalLine, Italic, Link, List, MediaEmbed, Mention, Paragraph, Table, Underline, Undo } from "ckeditor5";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import 'ckeditor5/ckeditor5.css';
import { Icon } from "@iconify/react/dist/iconify.js";

const countEditorWords = (html) => {
  if (!html) return 0;
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent || div.innerText || '';
  return text.trim().split(/\s+/).filter(Boolean).length;
};

class FormEditors extends Component {
  constructor(props) {
    super(props);
    this.editorInstance = null;
    this.lastValidData = props.value || '';
    this.isReverting = false;
    this.state = {}
  }

  render() {
    return (
      <React.Fragment>
        {this.props?.title && <FormLabel style={{ paddingBottom: "10px", fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B" }}>{this.props?.title}</FormLabel>}
        <CKEditor
          editor={ClassicEditor}
          data={this.props?.value}
          onChange={(event, editor) => {
            if (this.isReverting) return;
            const data = editor.getData();
            if (this.props?.maxWords && countEditorWords(data) > this.props.maxWords) {
              this.isReverting = true;
              editor.execute('undo');
              this.isReverting = false;
              return;
            }
            this.lastValidData = data;
            this.props?.setValue && this.props.setValue(data);
          }}
          disabled={this?.props?.disabled || false}
          config={{
            toolbar: {
              items: [
                // 'fontFamily',
                'bold',
                'italic',
                'underline',
                'fontSize',
                'fontColor',
                'fontBackgroundColor',
                'bulletedList',
                'numberedList',
                'alignment',
                'link',
                'insertTable',
                'horizontalLine',
                'undo',
                'redo', '|',
              ],
            },
            placeholder: this.props?.placeholder,
            plugins: [
              Bold,
              Essentials,
              Italic,
              Mention,
              Paragraph,
              Undo,
              FontFamily,
              FontSize,
              FontColor,
              FontBackgroundColor,
              Underline,
              List,
              Alignment,
              HorizontalLine,
              Link,
              Table
            ],
            // toolbar: {
            //   items: [
            //     'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
            //     '|',
            //     'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
            //     '|',
            //     'link', 'uploadImage', 'blockQuote', 'codeBlock',
            //     '|',
            //     'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent',
            //     '|',
            //     'alignment',
            //     '|',
            //     'undo', 'redo',
            //     '|',
            // ],
            // },

          }}
          onReady={(editor) => {
            this.editorInstance = editor;
            this.lastValidData = this.props.value || '';
          }}
        />
        {this.props?.error && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{this.props.error || ""}</FormHelperText>}
        {this.props?.helperText && <FormHelperText className='d-flex align-items-center m-0 mt-1'>{this.props.helperText || ""}</FormHelperText>}
      </React.Fragment>
    );
  };
};

export default FormEditors;
